import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import slide1 from "./components/slide-1";
import slide2 from "./components/slide-2";
import slide3 from "./components/slide-3";
import slide4 from "./components/slide-4";

const principle: Slide = {
  description: "Click on the arrows to discover the properties of the line arrays.",
  theory: theory,
  layout: {
    type: "carousel",
    options: {
      components: [slide1, slide2, slide3, slide4],
    },
  },
};

export default principle;
